import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import React, { useState, useEffect, useRef } from 'react'
import './Chat.scss'
import { useLocation } from 'react-router-dom';
import { getWhatsappDataBycommunityIdAdmin, getWhatsappDataBylenderIdAdmin, getWhatsappDataByUserIdAdmin, getWhatsappmsgByLoanId, sendWhatsAppMsg,uploadWhatsAppDoc , getWhatsappTemplateConfigApi, getAssignedLenders} from './CommActionCreator';
import Loader from '../../../../../../../presentationals/Loader/Loader.component';
import moment from 'moment';
import { LICENCE_ID } from '../../../../api-factory';
import whatsappLogo from '../../../Images/icons8-sent-48.png'


// let rolesData = window.sessionStorage.getItem('rolesData');



const Whatsapp = ({ rowData}) => {
    const [searchInput, setSearchInput] = useState({ lenderId: '', licenseId: '', communityId: '' })
    const [TemplateData, setTemplateData] = useState('')
    const [logsData, setLogsData] = useState('')
    const location = useLocation();
    const [comment, setComment] = useState('')
    const [loaderState, setLoaderState] = useState(false)
    const bottomRef = useRef(null);
    const [viewScreen, setviewScreen] = useState('user')
    const [assignedLender, setAssignedLender] = useState([])
    const [commentLenderId, setlenderId] = useState('')
    const [templateId, settemplateId] = useState('')
    const [lenderData, setLenderData] = useState('')
    const [jsonToSendApi, setJson] = useState('')
    const [selectedLender, setSelectedLender] = useState('')

    const getWhatsappChatByLoanId = () => {
        getWhatsappDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
            console.log(callBack.data)
            setLogsData(callBack)
            bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
        })
    }
    const templateHandler = (data) => {
        // settemplateId(data.target.value.templateId)
        // console.log(data.target.value.templateId)
        // setComment(data.target.value.body)
        // bottomRef.current?.scrollIntoView({ behavior: 'smooth' });

    }
    const newTemplateHandler = (data) => {
        settemplateId(data.templateId)
        setComment(data.body)
        // setSelectedLender(data)
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }


    const getAssignedLendersByApi = () => {
        getAssignedLenders(rowData.loanId, callBack => {
            console.log(callBack)
            setAssignedLender(callBack.data)
        })
    }
    const commentChangeHandler = (e) => {
        settemplateId('')
        setComment(e.target.value)
    }
    const sendMessage = (data) => {
        
        if (templateId && comment) {
            if (viewScreen === 'user') {
                let jsonToSend = {
                    "recieverId": rowData.userId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'USER',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(rowData.mobileNo),
                    "templateType": "template",
                    "body": comment ? comment : "",
                    "contentType": "text",
                    "templateId": templateId,
                    "attachmentUrl": null,
                    "loanId": rowData.loanId
                }
                setJson(jsonToSend)
                sendWhatsAppMsg(jsonToSend, callBack => {
                    console.log(callBack)
                    if (callBack === 'success') {
                        leadPageHandler(viewScreen, '')
                        setComment('')

                    }
                })
            }
            if (viewScreen === 'community') {
                let jsonToSendCommunity = {
                    "recieverId": rowData.communityId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'COMMUNITY',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '',
                    "templateType": "template",
                    "body": comment ? comment : "",
                    "contentType": "text",
                    "templateId": templateId,
                    "attachmentUrl": null,
                    "loanId": rowData.loanId
                }
                setJson(jsonToSendCommunity)
                sendWhatsAppMsg(jsonToSendCommunity, callBack => {
                    if (callBack === 'success') {
                        leadPageHandler(viewScreen, '')
                        setComment('')

                    }
                })
            }
            if (viewScreen.includes('lender')) {
                let jsonToSendLender = {
                    "recieverId": commentLenderId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'LENDER',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(lenderData.mobileNo),
                    "templateType": "template",
                    "body": comment ? comment : "",
                    "contentType": "text",
                    "templateId": templateId,
                    "attachmentUrl": null,
                    "loanId": rowData.loanId
                }
                console.log(jsonToSendLender)
                setJson(jsonToSendLender)
                sendWhatsAppMsg(jsonToSendLender, callBack => {
                    if (callBack === 'success') {
                        leadPageHandlerLender()
                        setComment('')

                    }
                })
            }
        }
        if (!templateId && comment) {

            if (viewScreen === 'user') {
                let jsonToSend = {
                    "recieverId": rowData.userId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'USER',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(rowData.mobileNo),
                    "templateType": "normal",
                    "body": comment ? comment : "",
                    "contentType": "text",
                    "templateId": null,
                    "attachmentUrl": null,
                    "loanId": rowData.loanId
                }
                setJson(jsonToSend)
                sendWhatsAppMsg(jsonToSend, callBack => {
                    if (callBack === 'success') {
                        leadPageHandler(viewScreen, '')
                        setComment('')

                    }
                })
            }
            if (viewScreen === 'community') {
                let jsonToSendCommunity = {
                    "recieverId": rowData.communityId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'COMMUNITY',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '',
                    "templateType": "normal",
                    "body": comment ? comment : "",
                    "contentType": "text",
                    "templateId": null,
                    "attachmentUrl": null,
                    "loanId": rowData.loanId
                }
                setJson(jsonToSendCommunity)
                sendWhatsAppMsg(jsonToSendCommunity, callBack => {
                    if (callBack === 'success') {
                        leadPageHandler(viewScreen, '')
                        setComment('')

                    }
                })
            }
            if (viewScreen.includes('lender')) {
                let jsonToSendLender = {
                    "recieverId": commentLenderId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'LENDER',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(lenderData.mobileNo),
                    "templateType": "normal",
                    "body": comment ? comment : "",
                    "contentType": "text",
                    "templateId": null,
                    "attachmentUrl": null,
                    "loanId": rowData.loanId
                }
                console.log(jsonToSendLender)
                setJson(jsonToSendLender)
                sendWhatsAppMsg(jsonToSendLender, callBack => {
                    if (callBack === 'success') {
                        leadPageHandlerLender()
                        setComment('')
                    }
                })
            }

        }
    }
    const leadPageHandlerLender =()=>{
        console.log(selectedLender)
        getWhatsappDataBylenderIdAdmin(rowData.loanId, selectedLender.lenderId, callBack => {
            setLogsData(callBack)
            bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
            setLoaderState(false)
            // setlenderId(selectedLender.lenderId)
        })
    }




    useEffect(() => {
        getWhatsappChatByLoanId();
        getWhatsappTemplates(1, 500)
        getAssignedLendersByApi()
    }, [])
    const getWhatsappTemplates = (page, rows) => {
        setLoaderState(true)
        console.log(page, rows, searchInput);
        getWhatsappTemplateConfigApi(page, rows, searchInput,
            callBack => {
                setTemplateData(callBack)
                setLoaderState(false)
            },
            error => {

            })
    }


    const leadPageHandler = (type, data) => {
        if (type === 'user') {
            setviewScreen(type)

            setLoaderState(true)
            getWhatsappDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })
        }
        if (type === 'community') {
            setviewScreen(type)
            setLoaderState(true)
            getWhatsappDataBycommunityIdAdmin(rowData.loanId, rowData.communityId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })
        }
        if (type === 'lender') {
            setSelectedLender(data)
            let view = type + data.lenderId
            setviewScreen(view)
            setlenderId(data.lenderId)
            setLenderData(data)
            setLoaderState(true)
            getWhatsappDataBylenderIdAdmin(rowData.loanId, data.lenderId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)
                setlenderId(data.lenderId)
            })
        }

    }
    const uploadWhatsAppDocFunction=(e)=>{
        // console.log(e.target.files[0],location.state.rowData,commentLenderId)
        setLoaderState(true)
        uploadWhatsAppDoc(e.target.files[0],rowData,commentLenderId,callBack=>{
            console.log(callBack)
            const type = e.target.files[0].type === 'image/png' ? 'image' : e.target.files[0].type === 'application/pdf' ? 'document' : e.target.files[0].type === 'image/jpg' ? 'image' : e.target.files[0].type === 'image/jpeg' ? 'image' : ''

            if(callBack){
            if(viewScreen==='user'){
                let jsonToSend = {
                    "recieverId": rowData.userId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'USER',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(rowData.mobileNo),
                    "templateType": "normal",
                    "body": comment ? comment : "",
                    "contentType": type?type:'document',
                    "templateId": null,
                    "attachmentUrl": callBack,
                    "loanId": rowData.loanId
                }
                setJson(jsonToSend)
                sendWhatsAppMsg(jsonToSend, callBack => {
                    console.log(callBack)
                    if (callBack === 'success') {
                        leadPageHandler(viewScreen, '')
                        setComment('')

                    }
                })
            }
            if (viewScreen === 'community') {
                let jsonToSendCommunity = {
                    "recieverId": rowData.communityId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'COMMUNITY',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(rowData.mobileNo),
                    "templateType": "normal",
                    "body": comment ? comment : "",
                    "contentType":type?type:'document',
                    "templateId": null,
                    "attachmentUrl": callBack,
                    "loanId": rowData.loanId
                }
                setJson(jsonToSendCommunity)
                sendWhatsAppMsg(jsonToSendCommunity, callBack => {
                    if (callBack === 'success') {
                        leadPageHandler(viewScreen, '')
                        setComment('')

                    }
                })
            }
            if (viewScreen.includes('lender')) {
                let jsonToSendLender = {
                    "recieverId": commentLenderId,
                    "type": "whatsapp",
                    "senderType": "license",
                    "recieverType": 'LENDER',
                    "senderId": LICENCE_ID,
                    "operationId": window.sessionStorage.getItem('adminId'),
                    "mobileNo": '91' + JSON.stringify(lenderData.mobileNo),
                    "templateType": "normal",
                    "body": comment ? comment : "",
                    "contentType": type?type:'document',
                    "templateId": null,
                    "attachmentUrl": callBack,
                    "loanId": rowData.loanId
                }
                console.log(jsonToSendLender)
                setJson(jsonToSendLender)
                sendWhatsAppMsg(jsonToSendLender, callBack => {
                    if (callBack === 'success') {
                        leadPageHandlerLender()
                        setComment('')
                    }
                })
            }

        }
        })
    }
    return (

        <div className="container-fluid full-height" style={{overflowX:'hidden'}}>

            {loaderState ?
                <Loader />
                : ""}

            <div className='row ' style={{ height: '90%' }}>
                <div className='col-sm-3 col-xs-12 side-chat-main ' >
                    <div className='comments-side-nav'>

                        <div className={viewScreen === 'user' ? 'chat-user-active' : 'chat-user'} >
                            <div className='row'>
                                <div className='col-sm-8 ' style={{ cursor: 'pointer' }} onClick={e => leadPageHandler('user', '')}>

                                    <button >User</button>

                                    <p>{rowData.name}</p>
                                </div>
                                <div className='col-sm-4 text-right'>

                                </div>
                            </div>
                        </div>
                        {rowData.communityId ?
                            <div className={viewScreen === 'community' ? 'chat-user-active' : 'chat-user'}>

                                <div className='row'>
                                    <div className='col-sm-8 ' style={{ cursor: 'pointer' }} s onClick={e => leadPageHandler('community', '')}>
                                        <button >Community</button>
                                        <p>{rowData.communityName}</p>
                                    </div>
                                    <div className='col-sm-4 text-right'>

                                    </div>
                                </div>
                            </div>
                            : ""}

                        {assignedLender && assignedLender.map((data, i) => {
                            return (
                                <div className={viewScreen.includes(data.lenderId) ? 'chat-user-active' : 'chat-user'} key={i} >
                                    <div className='row'>
                                        <div className='col-sm-8 ' style={{ cursor: 'pointer' }} onClick={e => leadPageHandler('lender', data)}>
                                            <button> {data.lenderName}</button>
                                            <p>Lender {i + 1}</p>
                                        </div>
                                        <div className='col-sm-4 text-right'>
                                        </div>
                                    </div>

                                </div>
                            )
                        })}

                    </div>
                </div>
                <div className='col-sm-9  col-xs-12'>
                    <div className='row'>
                        <div className='col-sm-6 col-xs-12 text-center'>
                            <h3 className='mt-3 mb-3 text-color'><b> Whatsapp Chat</b></h3>
                        </div>
                        <div className='col-sm-6 col-xs-12 '>
                            <FormControl size='small' variant="outlined" style={{ width: '100%' }}>
                                <InputLabel id="templateId">Template</InputLabel>
                                <Select
                                    labelId="templateId"
                                    id="templateId"
                                    value={templateId}
                                    onChange={e => templateHandler(e)}
                                    label="Template"
                                >
                                    <MenuItem value="">
                                        <em>Select Value</em>
                                    </MenuItem>
                                    {TemplateData ? TemplateData.map((data, i) => {
                                        if (data.templateId) {
                                            return (
                                                <MenuItem value={data.templateId} onClick={() => newTemplateHandler(data)}>{data.templateName}</MenuItem>
                                            )
                                        }
                                    }) : ""}

                                </Select>
                            </FormControl>

                        </div>


                    </div>
                    <div className='box bg-shadow whatsapp-bg' style={{ height: '500px', overflow: 'scroll', width: '100%' }}>
                        {logsData && logsData.data ?

                            <div className="">
                                <div className="mt-3">
                                    {logsData && logsData.data && logsData.data.map((row, i) => {
                                        return (
                                            <div key={i}>
                                                {row.operationId ?
                                                    <div className="chat-message-right pb-4">
                                                        <div className=" bg-you rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>

                                                            <div className='row'>
                                                                <div className="font-weight-bold mb-1 col-md-9">{row["operationName"]}</div>
                                                                <div className="mb-1 text-right" style={{ fontSize: '9px', marginTop: '-20px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                            </div>

                                                            {row['attachmentUrl']?
                                                            // <iframe src={row['attachmentUrl']}/>
                                                            row['attachmentUrl'].includes('pdf') ?
                                                            <iframe src={row.attachmentUrl}  />
                                                            : <img src={row.attachmentUrl} alt="" width='200px' />
                                                        
                                                        :""}
                                                        <br/>
                                                        {row["body"]}
                                                        </div>

                                                    </div> :
                                                    <div className="chat-message-left pb-4">
                                                        <div className="flecommunityNamex-shrink-1 bg-other rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>

                                                            <div className='row'>
                                                                <div className="font-weight-bold mb-1 col-sm-7">{row["communityName"] ? row["communityName"] : row["lenderName"] ? row["lenderName"] : row["userId"] ? row.userName : ""}</div>
                                                                <div className="mb-1 col-sm-5 text-right" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                            </div>

                                                            
                                                            
                                                            {row['attachmentUrl']?
                                                            // <iframe src={row['attachmentUrl']}/>
                                                            row['attachmentUrl'].includes('pdf') ?
                                                            <iframe src={row.attachmentUrl}  />
                                                            : <img src={row.attachmentUrl} alt="" width='200px' />
                                                        
                                                        :""}
                                                        <br/>
                                                        {row["body"]}
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        )
                                    })}
                                </div>

                                <div ref={bottomRef} ></div>
                            </div>
                            : ""}
                    </div>
                    {/* {(rolesData && rolesData.includes("comments")) || window.location.href.includes('community/leadDetail') ? */}
                        <div className="flex-grow-0 py-3 px-4 border-top">
                            <div className=" row chat-comment">

                                <div className='col-xs-12 col-sm-9 '>
                                    <TextField variant='standard' size='small' onChange={(e) => commentChangeHandler(e)} type="text" className="form-control" value={comment} label="Add Comment"style={{background:'#fff',boxShadow:"none"}}/>
                                </div>
                                <div className='col-xs-12 col-sm-1 mt-3'>
                                <div className="image-upload-wrap-multi-new">
                                        <input
                                            // value={objectData.fileValue}
                                          
                                            className="file-upload-input-multi-new" type='file'accept='.jpg,.png,.docs,.xls,.pdf'  onChange={(e)=>uploadWhatsAppDocFunction(e)} />

                                    </div>
                                {/* <i class="fa fa-paperclip" aria-hidden="true" style={{fontSize:'40px',color:'lightblue',cursor:'pointer'}}></i> */}
                                </div>
                                <div className='col-xs-12 col-sm-2 mt-3'>
                                    <button onClick={(e) => sendMessage(e)} className=""><img className='' src={whatsappLogo} style={{width:'40px'}}/></button>
                                </div>

                            </div>
                        </div>
                        {/* : ""} */}

                </div>
            </div>
        </div>
    )
}

export default Whatsapp;